const state = {
  ordinarySearchData: [],
  isLogin: false
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js